import React from "react";

const CompleteAccountSetup = ({ school }) => {
  const checklistItems = [
    {
      id: "term-dates",
      label: "Setup Terms Start and End Dates (1st, 2nd, 3rd)",
      isChecked: school?.settings?.terms?.length === 3 || false,
    },
    {
      id: "current-term-session",
      label: "Setup Current Term and Session",
      isChecked: !!(school?.settings?.current_session && school?.settings?.current_term),
    },
    {
      id: "result-settings",
      label: "Setup Result Settings (CA, Exams, Performance Grading)",
      isChecked: !!(school?.settings?.assessment && Object.keys(school?.settings?.assessment).length > 0),
    },
  ];

  // Check if all items are completed
  const isAllCompleted = checklistItems.every((item) => item.isChecked);

  // Calculate completion percentage
  const completedCount = checklistItems.filter(item => item.isChecked).length;
  const totalCount = checklistItems.length;
  const progress = Math.round((completedCount / totalCount) * 100);

  // Do not render if everything is completed
  if (isAllCompleted) return null;

  return (
    <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-gray-100 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-blue-50 rounded-full opacity-50 blur-2xl"></div>

      <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-6 relative z-10">
        <div>
          <h3 className="text-xl font-bold text-gray-900 mb-1">
            Complete Account Setup
          </h3>
          <p className="text-sm text-gray-500">
            {completedCount} of {totalCount} steps completed
          </p>
        </div>

        {/* Progress Bar */}
        <div className="w-full md:w-1/3 mt-4 md:mt-0">
          <div className="w-full bg-gray-100 rounded-full h-2.5">
            <div
              className="bg-[#4543B5] h-2.5 rounded-full transition-all duration-500 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="text-right text-xs font-semibold text-[#4543B5] mt-1">{progress}%</p>
        </div>
      </div>

      <div className="space-y-3 relative z-10">
        {checklistItems.map((item) => (
          <div
            key={item.id}
            className={`flex items-center p-4 rounded-xl border transition-all duration-300 ${item.isChecked
              ? 'bg-gray-50 border-gray-100 opacity-75'
              : 'bg-white border-gray-200 shadow-sm hover:border-[#4543B5] hover:shadow-md'
              }`}
          >
            <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mr-4 ${item.isChecked ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-400'
              }`}>
              {item.isChecked ? (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path></svg>
              ) : (
                <div className="w-2.5 h-2.5 rounded-full bg-gray-300"></div>
              )}
            </div>

            <div className="flex-1">
              <p className={`text-sm font-medium ${item.isChecked ? 'text-gray-500 line-through decoration-gray-400' : 'text-gray-800'}`}>
                {item.label}
              </p>
            </div>

            {!item.isChecked && (
              <div className="ml-2">
                <svg className="w-5 h-5 text-gray-300 transform -rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompleteAccountSetup;
